import React from 'react';
import { createTheme, adaptV4Theme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import theme from 'lib/config/retouch-rebranding-theme';

const lightTheme = createTheme(
  adaptV4Theme({
    palette: {
      type: 'light',
      primary: {
        ...theme.palette.primary,
      },
      secondary: {
        ...theme.palette.secondary,
      },
    },
  }),
);

const LightTextField = (props) => {
  const { children, ...otherProps } = props;
  return (
    <ThemeProvider theme={lightTheme}>
      <TextField variant="standard" {...otherProps}>
        {children}
      </TextField>
    </ThemeProvider>
  );
};

export default LightTextField;
